/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {TooltipEl} from 'common/components/tooltip';
import {SvgIconEl} from 'common/components/svg-icon';
import {Placement} from 'common/components/tooltip/types';
import {getReportNameFromSearchContext, getSearchIconFromDisplayContext} from 'common/report/util/search';
import {SearchDisplayContextTranslation} from 'common/report/util/search/types';
import {RowEntity} from 'common/widgets/entity-collection/entity-table/types';
import {getDashboardAllowedReports} from 'common/report/util/boards';
import {TEXT_HIGHLIGHT_THEME, TextHighlightEl} from 'common/components/text-highlight';

function getEntitySublabel(entity: RowEntity) {
  const report = getReportNameFromSearchContext(entity.displayContext);
  const isDashboardAllowedReport = getDashboardAllowedReports().includes(report);
  return isDashboardAllowedReport ? entity.dashboard : ``;
}

export const CellEntityNameWithIcon = ({
  entity,
  skipEntityLinks,
  skipEntityIcon,
}: {
  entity: RowEntity;
  skipEntityLinks: boolean;
  skipEntityIcon?: boolean;
}) => {
  const entityIcon = skipEntityIcon ? null : getSearchIconFromDisplayContext(entity.displayContext);
  const entityDisplayType = SearchDisplayContextTranslation[entity.displayContext];
  const entitySubLabel = getEntitySublabel(entity);

  const Badge = (text: string, tooltipText: string, theme: TEXT_HIGHLIGHT_THEME) => {
    return (
      <span sel='.cell-entity-badge'>
        <TextHighlightEl
          attrs={{
            text,
            theme,
          }}
        />
        <TooltipEl attrs={{placement: Placement.RightCenter, 'max-width': `250px`}}>{tooltipText}</TooltipEl>
      </span>
    );
  };

  return (
    <div sel='.cell-entity-name' class={{disabled: entity.isRowClickDisabled}}>
      {entityIcon ? (
        <div sel='.cell-entity-icon'>
          <SvgIconEl
            attrs={{
              icon: entityIcon,
            }}
          />
          <TooltipEl attrs={{placement: Placement.Right}}>{entityDisplayType}</TooltipEl>
        </div>
      ) : null}
      <div sel='.cell-entity-title'>
        <a sel='.entity-link' attrs={{...(skipEntityLinks ? {} : {href: entity.link})}}>
          {entity.name}
        </a>
        {entity.showDraftBadge &&
          Badge(
            `Draft`,
            `This Mixpanel board is currently a draft of a template. While in draft mode you cannot edit the board or add to the board until you’ve completed setting up the template.`,
            TEXT_HIGHLIGHT_THEME.FAILED,
          )}
        {entity.isRowClickDisabled &&
          Badge(`No access`, `This content is not shared with you.`, TEXT_HIGHLIGHT_THEME.GENERIC)}
        {entitySubLabel ? <div sel='.cell-entity-description'>{entitySubLabel}</div> : null}
      </div>
    </div>
  );
};
